/*
 * Copyright (c) 2015 - 2023 by KAA Soft. All rights reserved.
 */

import { adminConfig } from "../adminConfig";
import { httpRequest } from "./httpRequest";
import { loadingInput } from "./utils/loadingInput";

/**
 * @external KAAValidator
 * @param formId
 * @param form
 */
export function formValidation(formId, form) {
  adminConfig.forms[formId] = new KAAValidator(form, {
    errorTextClass: 'form-error',
    selector: 'input:not([type^=hidden]):not([type^=submit]):not([disabled]), select:not([disabled]), textarea:not([disabled])'
  });
}
/**
 * @property {boolean} isExist
 */
export function formValidationInit(containerSelector) {
  if (containerSelector === void 0) {
    containerSelector = 'body';
  }
  var container = document.querySelector(containerSelector);
  if (typeof KAAValidator === 'function') {
    var remoteValidationInputElements = container.querySelectorAll('[data-validator-rule-remote]');
    for (var i = 0; i < remoteValidationInputElements.length; i++) {
      remoteValidationInputElements[i].dataset.initValue = remoteValidationInputElements[i].value;
      remoteValidationInputElements[i].dataset.remote = true;
      remoteValidationInputElements[i].addEventListener("change", function (e) {
        e.preventDefault();
        var /** @type {HTMLElement} */self = e.target;
        var currentValue = self.value;
        var initValue = self.dataset.initValue;
        var route = self.dataset.route;
        var formId = self.dataset.form;
        if (!route) return console.warn(adminConfig.messages.routeNotSpecified);
        if (!formId) return console.warn(adminConfig.messages.formIdNotSpecified);
        var form = document.getElementById(formId);
        if (!form) return console.warn(adminConfig.messages.formNotExist);
        if (currentValue === initValue) return;
        var params = new URLSearchParams({
          'value': currentValue
        });
        loadingInput.start(self);
        httpRequest({
          url: route,
          data: params
        }).then(function (response) {
          if (response && response.data) {
            self.dataset.remote = !response.data.exists;
            adminConfig.forms[formId].validate(self);
          }
        })["catch"](function (error) {
          console.error(error);
        })["finally"](function () {
          loadingInput.finish(self);
        });
      });
    }
    var formElements = container.querySelectorAll("form");
    for (var _i = 0; _i < formElements.length; _i++) {
      var formId = formElements[_i].getAttribute('id');
      if (!formId) {
        formElements[_i].setAttribute('id', 'gen' + Date.now());
        formId = 'gen' + Date.now();
      }
      formValidation(formId, formElements[_i]);
    }
  } else {
    console.warn('Validator is not defined');
  }
}